<div class="flex flex-col max-h-[80vh] overflow-hidden rounded-2xl bg-white dark:bg-zinc-900" style="min-width: 360px; max-width: 100%;">
    <!-- Header -->
    <div class="flex items-center justify-between shrink-0 px-6 py-4 bg-primary text-white shadow-sm">
        <div class="flex items-center gap-x-2 min-w-0">
            <mat-icon
                class="icon-size-5 !text-white"
                [svgIcon]="data.mode === 'company' ? 'heroicons_outline:building-office-2' : 'heroicons_outline:building-storefront'"
            ></mat-icon>
            <h2 class="text-lg font-semibold !text-white truncate">{{ data.title }}</h2>
        </div>
        <button mat-icon-button class="shrink-0 !text-white hover:!bg-white/10" (click)="cancel()" aria-label="Close">
            <mat-icon class="!text-white" [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
        </button>
    </div>

    <!-- List -->
    <div class="flex-1 max-h-96 overflow-y-auto px-4 py-3">
        @if (!data.items?.length) {
        <div class="text-secondary px-2 py-8 text-center text-sm">
            No options available to switch.
        </div>
        } @else {
        <div class="flex flex-col gap-2">
            @for (item of data.items; track item.id) {
            <button
                type="button"
                class="flex w-full items-center gap-3 rounded-lg border px-4 py-3 text-left transition-colors"
                [ngClass]="{
                    'border-primary bg-hover': selectedId === item.id,
                    'opacity-60 cursor-not-allowed': isCurrent(item),
                    'hover:bg-hover': !isCurrent(item)
                }"
                [disabled]="isCurrent(item)"
                (click)="select(item)"
            >
                <mat-icon
                    class="icon-size-6 text-hint"
                    [svgIcon]="data.mode === 'company' ? 'heroicons_outline:building-office-2' : 'heroicons_outline:building-storefront'"
                ></mat-icon>
                <div class="flex min-w-0 flex-auto flex-col">
                    <span class="truncate font-medium">{{ item.name }}</span>
                    @if (subtitle(item)) {
                    <span class="text-secondary truncate text-sm">{{ subtitle(item) }}</span>
                    }
                </div>
                @if (isCurrent(item)) {
                <span class="text-secondary shrink-0 text-xs font-medium">Current</span>
                } @else if (selectedId === item.id) {
                <mat-icon class="text-primary icon-size-5 shrink-0" [svgIcon]="'heroicons_solid:check-circle'"></mat-icon>
                }
            </button>
            }
        </div>
        }
    </div>

    <!-- Actions -->
    <div class="flex items-center justify-end gap-2 shrink-0 border-t border-neutral-200 bg-zinc-50 px-6 py-4 dark:border-neutral-700 dark:bg-zinc-900/50">
        <button mat-stroked-button (click)="cancel()">Cancel</button>
        <button
            mat-flat-button
            color="primary"
            [disabled]="!selectedId"
            (click)="confirm()"
        >
            <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:check'"></mat-icon>
            <span class="ms-1">Switch</span>
        </button>
    </div>
</div>
